import { common } from "./common.js";
import MicroModal from 'micromodal';

MicroModal.init({
    disableScroll: true,
});

common();
